module.exports = __webpack_public_path__ + "img/active1.2d46c75f.svg";